import UtilsSchema from "@repoflow/schema/utils";

import {
  orgId,
  pointId,

  description,
  measures,
  dimensions,
  createdAt,
  updatedAt
} from "./fields";

export default [
  ...UtilsSchema,
  {
    id: "/Public/Point",
    type: "object",
    properties: {
      orgId,
      pointId,
      description,
      measures,
      dimensions,
      createdAt,
      updatedAt
    }
  },
  {
    id: "/Public/Point/Create",
    type: "object",
    properties: {
      description,
      measures,
      dimensions,
    },
    // Every required array in this project was empty, which is why assertValid
    // had nothing to assert (A9 in docs/datum-api.md). `description` is already
    // `String!` on PointInputCreate, so tightening this cannot reject a request
    // GraphQL would have accepted — it only stops the model layer being
    // reachable with less than the contract promises.
    required: ["description"],
  },
  {
    id: "/Public/Point/Update",
    type: "object",
    properties: {
      description,
      measures,
      dimensions,
    },
    required: ["description"],
  },
];
